import * as ActionTypes from '../ActionTypes';

export const GetCandidateSourceAction = (params) => {
    return {
        type: ActionTypes.CANDIDATE_SOURCE_GET_REQUEST,
        params
    }
}

export const UpsertCandidateSourceAction = (params) => {
    return {
        type: ActionTypes.CANDIDATE_SOURCE_UPSERT_REQUEST,
        params
    }
}

export const DeleteCandidateSourceAction = (params) => {
    return {
        type: ActionTypes.CANDIDATE_SOURCE_DELETE_REQUEST,
        params
    }
}
